import * as React from "react";

const IconFilterArrowUp: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="#999"
                fillRule="evenodd"
                d="M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm.238 6.104a.324.324 0 00-.476 0l-2.163 2.29c-.212.224-.062.606.237.606h4.328c.299 0 .449-.382.237-.607z"
            />
        </svg>
    );
};

export default React.memo(IconFilterArrowUp);
